import React, { useState, useEffect } from 'react';
import { User } from '../types';
import useUser from 'hooks/useUser';

const Profile: React.FC = () => {
  const { user } = useUser();

  return (
    <div>
      <h1>Profile</h1>
      {user && (
        <div>
          <p>
            <strong>Name:</strong> {user.firstName}
          </p>
          <p>
            <strong>Name:</strong> {user.lastName}
          </p>
          <p>
            <strong>Email:</strong> {user.email}
          </p>
        </div>
      )}
    </div>
  );
};

export default Profile;
